const Spinner = () => (<div className="d-flex justify-content-center">
    <span className="loader"></span>
</div>);

export default Spinner;